import { defineStore } from 'pinia'
import { ref } from 'vue'

export const NOTIFICATION_TYPE = {
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
    INFO: 'INFO',
}

const EMPTY_NOTIFICATION = {
    type: NOTIFICATION_TYPE.SUCCESS,
    asToast: false,
    content: '',
    submitText: '',
    cancelText: null,
    onConfirm: () => {},
    onClose: () => {},
}

export const useNotificationStore = defineStore('notification', () => {
    const hasActiveNotification = ref(false)
    const notification = ref(EMPTY_NOTIFICATION)
    let onDisplayCallbacks = []
    let onHideCallbacks = []

    function onDisplay(callback) {
        onDisplayCallbacks.push(callback)
    }

    function onHide(callback) {
        onHideCallbacks.push(callback)
    }

    function showNotification(displayedNotification) {
        hasActiveNotification.value = true
        notification.value = displayedNotification
        onDisplayCallbacks.forEach((callback) => callback())
    }

    function hideNotification() {
        hasActiveNotification.value = false
        notification.value = EMPTY_NOTIFICATION
        onHideCallbacks.forEach((callback) => callback())
    }

    return {
        hasActiveNotification,
        notification,
        onDisplay,
        onHide,
        showNotification,
        hideNotification,
    }
})
